import React from 'react'

const AppleInfo = () => {
  return (
    <div>AppleInfo</div>
  )
}

export default AppleInfo